<template>
  <div>
    <div class="row">
      <h5 class="filter-text">{{ $t("filterBy:") }}</h5>
      <v-card flat class="col-12 p-2">
        <form class="row" @submit.prevent="searchForStudents(filter)">
          <div class="col-lg-4">
            <v-text-field
              v-model.lazy="filter.user_id"
              :label="$t('studentList.studentID')"
              filled
              clearable
              color="green"
              clear-icon="mdi-close-circle"
              type="number"
            ></v-text-field>
          </div>
          <div class="col-lg-4">
            <v-text-field
              v-model.lazy="filter.name"
              :label="$t('studentName')"
              filled
              clearable
              color="green"
              clear-icon="mdi-close-circle"
            ></v-text-field>
          </div>
          <div class="col-lg-4">
            <v-text-field
              v-model.lazy="filter.email"
              :label="$t('studentList.studentEmail')"
              filled
              clearable
              color="green"
              clear-icon="mdi-close-circle"
            ></v-text-field>
          </div>
          <div
            class="col d-flex justify-content-center md-justify-content-end align-items-center mb-1"
          >
            <v-btn color="success" type="submit" class="me-4">
              {{ $t("search") }}
            </v-btn>
            <v-btn color="error" @click="resetFilter">
              {{ $t("clear") }}
            </v-btn>
          </div>
        </form>
      </v-card>
    </div>
    <v-data-table
      class="mt-5 students-list"
      :headers="tableHeaders"
      :items="students"
      :sort-by="tableOptions.sortBy"
      :sort-desc="tableOptions.sortDesc"
      item-key="id"
      :footer-props="{
        'show-current-page': true,
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
      }"
      :items-per-page="tableOptions.itemsPerPage"
      :server-items-length="totalStudents"
      :no-data-text="noDataText"
      :page="tableOptions.page"
      :options="tableOptions"
      @update:options="updateStudents"
      mobile-breakpoint="667"
    >
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click.stop="saveStudentId(item)"
            >
              mdi-account-check
            </v-icon>
          </template>
          <span>{{$t("chooseStudent")}}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import GlobalMixin from "../../GlobalMixin";

export default {
  name: "StudentList",
  mixins: [GlobalMixin],
  data() {
    return {
      // Filter Parameters
      filter: {
        user_id: "",
        name: "",
        email: "",
      },
      students: [],
      totalStudents: null,

      tableFooterOptions: {
        "items-per-page-options": [10, 20, 30, 40, 50, 100],
        "show-current-page": true,
        showFirstLastPage: true,
        firstIcon: "mdi-arrow-collapse-left",
        lastIcon: "mdi-arrow-collapse-right",
      },
      tableOptions: {
        page: 1,
        offset: +this.$route.query.offset ? +this.$route.query.offset : 0,
        itemsPerPage: +this.$route.query.limit ? +this.$route.query.limit : 10,
        sortBy: [],
        sortDesc: [],
      },
      search: {},
      noDataText: " ",
    };
  },
  methods: {
    resetFilter() {
      this.getAllInstituteStudents();
    },
    getAllInstituteStudents(
      offset = 0,
      limit = this.tableOptions.itemsPerPage,
      sortBy,
      sortOrder,
      search
    ) {
      const body = {
        institute: this.currentIns,
        offset,
        limit,
        sort_field: sortBy,
        sort_order:
          typeof sortOrder === "boolean"
            ? sortOrder
              ? "desc"
              : "asc"
            : undefined,
        ...search,
      };

      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}auth/students_list/`,
          body,
          this.headers
        )
        .then((res) => {
          this.students = res.data.students;
          this.totalStudents = res.data.total_records;

          // Handle Shown text if there's no Data
          !this.students.length && !Object.keys(this.search).length
            ? (this.noDataText = "No Available Data.")
            : (this.noDataText = "There is No Result.");
        })
        .catch((err) => this.formatErrors(err));
    },
    /**
     * Emits when one of the options properties is updated
     * @param options table info
     */
    updateStudents(options) {
      this.tableOptions.sortBy = options.sortBy;
      this.tableOptions.sortDesc = options.sortDesc;
      if (!this.currentIns) this.currentIns = this.getInstituteId;
      // Get necessary values for table (itemsPerPage, page, offset)
      this.tableOptions.offset = options.itemsPerPage * (options.page - 1);
      this.tableOptions.itemsPerPage = options.itemsPerPage;
      this.tableOptions.page = this.tableOptions.offset
        ? this.tableOptions.offset / this.tableOptions.itemsPerPage + 1
        : 1;
      // Get updated students with new params
      this.getAllInstituteStudents(
        this.tableOptions.offset,
        this.tableOptions.itemsPerPage,
        this.tableOptions.sortBy[0],
        this.tableOptions.sortDesc[0],
        this.search
      );
    },
    /**
     * Handle search parameters and get new table data
     * @param searchObj search parameters
     */
    searchForStudents(searchObj) {
      this.search = {};
      for (let key in searchObj) {
        switch (key) {
          case "name":
          case "user_id":
          case "email":
            if (!searchObj[key]) break;
            this.search[key] = searchObj[key];
            break;
        }
      }

      this.tableOptions.offset = 0;
      this.tableOptions.itemsPerPage = 15;
      this.tableOptions.page = 1;
      this.tableOptions.sortBy = [];
      this.tableOptions.sortDesc = [];
      this.getAllInstituteStudents(
        this.tableOptions.offset,
        this.tableOptions.itemsPerPage,
        this.tableOptions.sortBy[0],
        this.tableOptions.sortDesc[0],
        this.search
      );
    },
    ...mapActions(["saveStudentToStore"]),
    saveStudentId(student) {
      this.saveStudentToStore(student);
      this.$emit("saveStudentId", false);
    },
  },
  computed: {
    tableHeaders() {
      return [
        { text: this.$t("tables.id"), value: "id" },
        { text: this.$t("tables.name"), value: "full_name" },
        { text: this.$t("studentList.studentEmail"), value: "email" },
        { text: this.$t("tables.gender"), value: "gender" },
        { text: this.$t("tables.status"), value: "active_text" },
        { text: this.$t("tables.actions"), value: "actions", sortable: false },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-text {
  color: #9f9f9f;
  margin-top: 2.5rem;
}
</style>
